import {
  EventManager,
  Profiler,
  RecommendationController,
  UrlManager,
  UrlTranslator,
  reactLinker
} from "./chunk--chunk-HKR66ONA.vbt.js";
import {
  Client,
  Logger,
  Tracker
} from "./chunk--chunk-XJAOVGY2.vbt.js";
import {
  RecommendationStore
} from "./chunk--chunk-GSFZ3OSC.vbt.js";

// node_modules/@searchspring/snap-preact/dist/esm/create/createRecommendationController.js
var createRecommendationController_default = (config, services) => {
  const urlManager = (services?.urlManager || new UrlManager(new UrlTranslator(config.url), reactLinker)).detach(true);
  if (config.mode && config.client) {
    config.client.config = config.client.config || {};
    config.client.config.mode = config.mode;
  }
  const cntrlr = new RecommendationController(config.controller, {
    client: services?.client || new Client(config.client.globals, config.client.config),
    store: services?.store || new RecommendationStore(config.controller, { urlManager }),
    urlManager,
    eventManager: services?.eventManager || new EventManager(),
    profiler: services?.profiler || new Profiler(),
    logger: services?.logger || new Logger({ mode: config.mode }),
    tracker: services?.tracker || new Tracker(config.client.globals)
  }, config.context);
  return cntrlr;
};

export {
  createRecommendationController_default
};
